import React, { useEffect } from 'react';
import { Review } from '.';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReviewList = function ReviewList(_ref) {
  var serviceReviews = _ref.serviceReviews,
      service = _ref.service,
      getServiceReviews = _ref.getServiceReviews;
  var serviceId = service === null || service === void 0 ? void 0 : service.id;
  useEffect(function () {
    if (serviceId) {
      getServiceReviews(serviceId);
    }
  }, [serviceId]);
  var currentServiceReviews = serviceReviews[serviceId];
  return (currentServiceReviews === null || currentServiceReviews === void 0 ? void 0 : currentServiceReviews.length) > 0 ? /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center justify-center mb-12 md:mb-14",
    children: [/*#__PURE__*/_jsx("img", {
      className: "w-7 h-auto",
      src: "/images/squiggle-13-lg.png",
      alt: "squiggle"
    }), /*#__PURE__*/_jsx("h3", {
      className: "text-lg mt-2 mb-0 text-center",
      children: "".concat(service === null || service === void 0 ? void 0 : service.name, " Subscribers Say...")
    }), currentServiceReviews.map(function (review) {
      return /*#__PURE__*/_jsx(Review, {
        review: review
      }, review.id);
    })]
  }) : null;
};
ReviewList.defaultProps = {};